import {ACTION_CODE} from './_actionCode';
import {ReferenceService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DOWNLOAD_REFERENCE_BY_ID';

export async function downloadReferenceById(userData: Record<string, any>, id: number) {
    try {
        LoggerService.logInfo('Action - downloadReferenceById - Start');

        const downloadReferenceByIdResult = await ReferenceService.downloadReferenceById(userData, id);

        LoggerService.logInfo('Action - downloadReferenceById - End - Success');

        return ResultModel.newSuccessResult(downloadReferenceByIdResult);
    }
    catch (error: any) {
        LoggerService.logInfo('Action - downloadReferenceById - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors du téléchargement de la référence.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
